var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "lg",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function (ref) {
            var close = ref.close
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n\t\t\t\tClose Modal\n\t\t\t")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function (ref) {
            var close = ref.close
            return [
              _c("div", { staticClass: "modal-footer" }, [
                _vm.product.id > 0
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.remove(false)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__t("REMOVE")) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.__t("CLOSE")) + "\n\t\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.save_product },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.__t("SAVE")) + "\n\t\t\t\t"
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_user_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _c("span", { staticClass: "fw-300" }, [
                  _vm._v("ID:" + _vm._s(this.product.id)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-container show" },
            [
              _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
                _vm.product.id >= 0
                  ? _c("div", { staticClass: "panel-content" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column align-items-center justify-content-center p-4",
                        },
                        [
                          _c(
                            "h5",
                            { staticClass: "mb-0 fw-700 text-center mt-3" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(this.product.title) +
                                  "\n\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "b-tabs",
                            { attrs: { "content-class": "mt-3" } },
                            _vm._l(_vm.tabs, function (tab, index) {
                              return _c(
                                "b-tab",
                                {
                                  key: index,
                                  attrs: {
                                    disabled: tab.disabled,
                                    title: _vm.get_tab_title(tab),
                                    active: tab.is_active,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.set_active(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "title" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.get_tab_title(tab)) +
                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                      ),
                                      tab.is_load
                                        ? _c("b-spinner", {
                                            attrs: { type: "grow", small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(tab.index, {
                                    tag: "component",
                                    attrs: {
                                      product_type: _vm.item_type,
                                      product: _vm.product,
                                    },
                                    on: { on_change: _vm.set_product_param },
                                  }),
                                ],
                                2
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }